/* unplugin-vue-components disabled */import { render } from "./PayOnline.vue?vue&type=template&id=5678a878&scoped=true"
import script from "./PayOnline.vue?vue&type=script&lang=js"
export * from "./PayOnline.vue?vue&type=script&lang=js"

import "./PayOnline.vue?vue&type=style&index=0&id=5678a878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5678a878"]])

export default __exports__